// removed by extract-text-webpack-plugin
module.exports = {"underlinedWord":"underlinedWord--28Rsv","glossaryLink":"glossaryLink--QqvDw"};